// Busca no mapa
export class MapSearchHandler {
    constructor(controller) {
        this.controller = controller
        this.searchBox = null
    }

    init() {
        if (!this.controller.hasSearchTarget || !this.controller.map) return

        this.searchBox = new google.maps.places.SearchBox(this.controller.searchTarget)

        this.controller.map.addListener("bounds_changed", () => {
            this.searchBox.setBounds(this.controller.map.getBounds())
        })

        this.searchBox.addListener("places_changed", () => {
            const places = this.searchBox.getPlaces()
            if (places.length === 0) return

            const place = places[0]
            if (!place.geometry?.location) return

            if (place.geometry.viewport) {
                this.controller.map.fitBounds(place.geometry.viewport)
            } else {
                this.controller.map.setCenter(place.geometry.location)
                this.controller.map.setZoom(15)
            }
        })
    }
}